// ── innernet labs: the areas by name only (client-safe, tiny) ──────────────
// The ≡ menu is in every page's client bundle, so it reads this list and never
// the full registry (lib/labs/areas, which carries the evidence and its data
// files). The two are held together by lib/labs/content.test.ts.

export const LAB_AREA_NAMES = [
  { slug: 'memory', name: 'innernet memory' },
  { slug: 'person-model', name: 'netti-1, the person model' },
  { slug: 'group-model', name: 'the group model' },
  { slug: 'infinite-window', name: 'the infinite window' },
  { slug: 'resonance', name: 'the resonance model' },
  { slug: 'agent-identity', name: 'agent identity' },
] as const

/** the labs space in the ≡ menu: the six areas, then the papers, the notes, the benchmarks and likeness */
export function labsSections(): { key: string; label: string; href: string }[] {
  return [
    ...LAB_AREA_NAMES.map((a) => ({ key: a.slug, label: a.name, href: `/labs/${a.slug}` })),
    { key: 'papers', label: 'papers', href: '/labs#papers' },
    { key: 'notes', label: 'notes', href: '/labs#notes' },
    { key: 'benchmarks', label: 'benchmarks', href: '/labs/benchmarks' },
    { key: 'likeness', label: 'likeness, the person benchmark', href: '/labs/likeness' },
  ]
}
